import React from 'react';

const Projects = () => {
    return (
        <div className=''>
            <h1>Projects</h1>
            this will contain tabs on various topics that i like, and the first page will have like top 6 pages, hopefully in a carousal so that you people can look through them, but in different tabs. Each tab representing a different topic. 
            There will also be a page for each project. it could be the github link to that page or a separate page in itself. but yeah mostly the github link. 
        </div>
    );
}

export default Projects;
